/**
 * Object의 keys를 string literal 타입으로 이용하고 싶을 때 사용.
 */
export const getTypedObjectKeys = <T extends {[index: string]: any}>(
  object: T
): (keyof T)[] => {
  return Object.keys(object);
};
